import { createSelector } from 'reselect';

export const selectLocalState = () => state => state.groups;

export const selectGroupData = () =>
    createSelector(
        selectLocalState(),
        ({ data }) => data
    );
